export default __webpack_public_path__ + "static/info-messages-flag-a26f8840566cbb87b270233e0ca08489.png";